module.exports = "module.exports = __webpack_public_path__ + \"static/media/map-s2-helmand-and-kandahar.cb3cecd1.svg\";";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./src/content/figures/m/map-s2-helmand-and-kandahar.svg
// module id = 1382
// module chunks = 0